import React from 'react';
import { Card, CardBody, Row, Table } from 'reactstrap';
import classnames from 'classnames';
import { Colxx, Separator } from '../../components/common/CustomBootstrap';
import moment from 'moment';
import IntlMessages from '../../helpers/IntlMessages';
import { buildOrderVariantBadges } from '../../helpers/OrderVariantBadges';

class ComponentToPrint extends React.Component {
    componentWillUnmount() {
        document.body.classList.remove('noscroll');
    }

    render() {
        let {
            items,
            discount,
            cardWrapper,
            billDate,
            pin_print = '',
            show_variant_badges = false,
        } = this.props;

        const displayPinPrint = (() => {
            if (!pin_print) return "";
            
            // Phân tách ngày linh hoạt để tránh lỗi "Invalid Date"
            const dateToParse = billDate || moment().format("DD/MM/YYYY"); 
            let mDate = moment(dateToParse, "DD/MM/YYYY");
            if (!mDate.isValid()) mDate = moment(dateToParse); // Thử parse tự động nếu format DD/MM/YYYY không khớp
            if (!mDate.isValid()) mDate = moment().utcOffset(7); // Fallback về giờ VN hiện tại
            
            const prefix = mDate.format("YYMMDD");
            let pinStr = String(pin_print);

            // Nếu pinStr bắt đầu bằng 6 chữ số (có thể là prefix ngày cũ), hãy loại bỏ nó trước khi gắn prefix mới
            // Chỉ loại bỏ nếu nó không khớp với prefix hiện tại ta muốn
            if (/^\d{6}/.test(pinStr) && !pinStr.startsWith(prefix)) {
                pinStr = pinStr.substring(6);
            }

            if (pinStr.startsWith(prefix)) return pinStr;
            if (
                pinStr.includes("+") ||
                pinStr.includes("HĐ") ||
                pinStr.includes("HD")
            )
                return pinStr;
            return `${prefix}${pinStr}`;
        })();

        const fullName = localStorage.getItem('fullname');
        const timeNow = moment(new Date()).format('HH:mm');

        return !items.length ? (
            <div className='loading' />
        ) : (
            <Row className='invoice-react' id='bill-to-print'>
                <Colxx xxs='12' className='mb-4'>
                    <Card
                        className={classnames('mb-5 invoice-contents p-2', {
                            card: !cardWrapper,
                        })}
                    >
                        <CardBody className='d-flex flex-column justify-content-between p-2'>
                            <div
                                className={classnames(
                                    'd-flex flex-column align-self-center order-invoice p-0 w-100',
                                    {
                                        'card-body': !cardWrapper,
                                    }
                                )}
                            >
                                <div className='d-flex flex-row justify-content-between mb-3'>
                                    <div className='d-flex flex-column justify-content-center align-items-start w-55 mr-2 py-2 text-semi-muted bg-area-print'>
                                        <span className='mb-2 text-small text-to-print'>
                                            <IntlMessages id='print.cashier' />:{' '}
                                            {fullName}
                                        </span>
                                        <span className='mb-2 text-small text-to-print'>
                                            #{displayPinPrint}
                                        </span>
                                    </div>
                                    <div className=' w-45 d-flex flex-column justify-content-center text-right py-2 text-semi-muted bg-area-print'>
                                        <span className='mb-2 text-small text-to-print'>
                                            {billDate}
                                        </span>
                                        <span className='mb-0 text-small text-to-print'>
                                            {timeNow}
                                        </span>
                                    </div>
                                </div>
                                <Separator className='mb-2' />
                                <Table borderless>
                                    <thead>
                                        <style>{`@media print {.no-print{display: none;}}`}</style>
                                        <tr>
                                            <th className='text-muted pd-light text-extra-small mb-2 text-to-print'>
                                                <IntlMessages id='print.quantity' />
                                            </th>
                                            <th className='text-left pd-light text-muted text-extra-small mb-2 text-to-print'>
                                                <IntlMessages id='print.name-product' />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items?.length &&
                                            items?.map((item, idx) => {
                                                const variantBadges = show_variant_badges
                                                    ? buildOrderVariantBadges(item)
                                                    : [];

                                                return (
                                                    <React.Fragment key={idx}>
                                                        <tr>
                                                            <td className='text-to-print pd-light text-primary'>
                                                                {item?.count}
                                                            </td>
                                                            <td className='text-to-print pd-light text-left'>
                                                                <div>{item?.product?.name}</div>
                                                                {variantBadges.length ? (
                                                                    <div className='print-variant-badges'>
                                                                        {variantBadges.map((badge, badgeIdx) => (
                                                                            <span
                                                                                className='print-variant-badge'
                                                                                key={`${badge}-${badgeIdx}`}
                                                                            >
                                                                                {badge}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                ) : null}
                                                            </td>
                                                        </tr>
                                                        {(discount &&
                                                            discount.saved &&
                                                            discount.note) ||
                                                        (item?.discount &&
                                                            item?.discount.note) ? (
                                                            <tr>
                                                                <td
                                                                    className='discount-note no-print pd-light'
                                                                    colSpan='4'
                                                                >
                                                                    {`* ${GetDiscountOrderNote(
                                                                        discount,
                                                                        item
                                                                    )}`}
                                                                </td>
                                                            </tr>
                                                        ) : null}
                                                    </React.Fragment>
                                                );
                                            })}
                                    </tbody>
                                </Table>
                            </div>
                            {/* <div className='d-flex flex-column'>
                                <span className='text-small text-center'>
                                    Bản quyền thuộc vmass.vn.
                                </span>
                            </div> */}
                        </CardBody>
                    </Card>
                </Colxx>
            </Row>
        );
    }
}

export default ComponentToPrint;

const GetDiscountOrderNote = (discount, item) => {
    let note = '';

    if (discount && discount.saved && discount.note) {
        note = discount.note;
    } else if (item.discount) {
        note = item.discount.note;
    }
    return note;
};
